/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Group_From_JsonInputs */

const en_sidebar_group_from_json = /** @type {(inputs: Sidebar_Group_From_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From JSON`)
};

const ko_sidebar_group_from_json = /** @type {(inputs: Sidebar_Group_From_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에서 변환`)
};

const ja_sidebar_group_from_json = /** @type {(inputs: Sidebar_Group_From_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONから変換`)
};

/**
* | output |
* | --- |
* | "From JSON" |
*
* @param {Sidebar_Group_From_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_group_from_json = /** @type {((inputs?: Sidebar_Group_From_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Group_From_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_group_from_json(inputs)
	if (locale === "ko") return ko_sidebar_group_from_json(inputs)
	return ja_sidebar_group_from_json(inputs)
});